var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-page',{attrs:{"columns":_vm.columns,"headers":_vm.headers,"show-add-button":false,"sort":"invoiceId","title":"Shanto IT Invoices","icon":"mdi-equal-box","stateendpoint":"shantoitInvoice.shantoitInvoices","actions":_vm.actions,"show-default-action-buttons":false,"show-shantoit-selector":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }